import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {PaymentNewCardPage} from "../payment-new-card/payment-new-card";
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";
import {Validators, FormBuilder, FormGroup} from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-payment-change-method-popover',
  templateUrl: 'payment-change-method-popover.html',
})
export class PaymentChangeMethodPopoverPage {

  public loading: boolean;
  public paymentCardsForm: FormGroup;
  public paymentMethods: any;
  public defaultPaymentMethod: any;
  public selectedPaymentMethod: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public stripeService: StripeServiceProvider,
    private formBuilder: FormBuilder,
  ) {
    this.paymentMethods = this.navParams.get('paymentMethods') ? this.navParams.get('paymentMethods').data : null;
    this.defaultPaymentMethod = this.navParams.get('defaultPaymentMethod') ? this.navParams.get('defaultPaymentMethod') : null;

    this.paymentCardsForm = this.formBuilder.group({
      paymentMethod: [this.defaultPaymentMethod.id, Validators.required],
    })
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

  onChangeHandler(event: string) {
    this.selectedPaymentMethod = event
  }

  addPaymentMethod() {
    this.navCtrl.push(PaymentNewCardPage, {referrer: 'paymentPage'}).then(()=>{
      this.viewCtrl.dismiss();
    });

  }

  saveCard() {
    this.loading = true;
    this.stripeService.changePaymentMethod(this.selectedPaymentMethod).then((customer) => {
      this.viewCtrl.dismiss(customer).then(() => {
        this.loading = false;
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment-change-method-popover/payment-change-method-popover.ts